import styles from "./styles/NewHome.module.css";
import { Button, Layout, Popover, Spin } from "antd";
import { useAtom } from "jotai";
import React, { Suspense, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router";
import { useApps } from "../actions/app/app";
import Editor from "../editor/Editor";
import MainBar from "./MainBar";
import QurealApp from "../schema/QurealApp";
import { selectedMenuAtom } from "../states/navigation";
import QurealAppSingleScreen from "../schema/QurealAppSingleScreen";
import TopBar from "../common/TopBar";
import { TOPBAR_HEIGHT } from "../constants";
import { useCurrentUser, useLogout } from "../actions/auth";
import useMedia from "react-use/lib/useMedia";
import log from "cslog";
import { useCreateOrg, useSelecteOrgMutation } from "../actions/org";

import VerifyOTP from "../auth/VerifyOTP";
import { history } from "../_helpers/history";
import { useQueryParams } from "../_helpers/query";
import PageNotFound from "../common/404";
// import Celebration from "./Celebration";
import cn from "classnames";

import { Link, useRouteMatch } from "react-router-dom";
import { getHeroIcon } from "../_helpers/heroicons";
import ContentCalender from "../content_calender/ContentCalender";
import { OrgDropdown } from "../common/TopBarOptions";
import QurealSpotlight from "../creations/QurealSpotlight";
import Logo from "../common/Logo";
import TokenManagerModal from "../finance/TokenManagerModal";
import TokenCounter from "../finance/TokenCounter";
import { BgColorsOutlined } from "@ant-design/icons";
import ThemeSelector from "../common/ThemeSelector";
import NewMobileNavBar from "./NewMobileNavBar";
import AIHome from "../ai_home/AIHome";
import PlainLoading from "../common/PlainLoading";

const Celebration = React.lazy(() => import("./Celebration"));

// Tab-level lazy loading — heavy feature chunks loaded on first navigation
// const AIHome = React.lazy(() => import("../ai_home/AIHome"));

const ContentCalenderNew = React.lazy(() =>
    import("../content_calender_new/ContentCalenderNew")
);
const MobileMenuScreen = React.lazy(() => import("./MobileMenuScreen"));
const MobileCreatePanelStandalone = React.lazy(() =>
    import("../content_calender_new/NewAddPanel").then((m) => ({
        default: m.MobileCreatePanelStandalone,
    }))
);

const APPS = {
    home: {
        slug: "home",
        name: "Home",
        icon: "sparkles",
        component: AIHome,
    },
    calendar: {
        slug: "creatives/content-calendar",
        name: "Calendar",
        icon: "calendar",
        component: ContentCalenderNew,
    },
    sources: {
        slug: "sources",
        name: "Sources",
        icon: "bolt",
        component: (props) => <h3>Generate from sources</h3>,
    },
    creatives: {
        slug: "creatives",
        name: "Creatives",
        icon: "squares-plus",
        component: (props) => (
            <QurealApp
                {...props}
                app={{
                    slug: "creatives",
                    name: "Creatives",
                    layout: {
                        type: "multiscreen",
                        navigation: {
                            type: "sidebar",
                            theme: "light",
                        },
                    },
                    default_screen_index: 0,
                    screens: [
                        {
                            id: 10,
                            status: "published",
                            sort: 9,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2023-11-30T13:11:51",
                            name: "All Creations",
                            slug: "all",
                            icon: "fas fa-th",
                            layout: {
                                type: "qmade",
                                screen: "creative_all_creations",
                            },
                            app: 4,
                            type: "qbuilt",
                            components: [25],
                        },
                        {
                            id: 53,
                            status: "published",
                            sort: 10,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-03-31T10:40:55",
                            name: "Content Calendar",
                            slug: "content-calendar",
                            icon: "fas fa-calendar-alt",
                            layout: {
                                screen: "content_calender_new",
                            },
                            app: 4,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 49,
                            status: "published",
                            sort: 11,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-04-05T10:25:48",
                            name: "Festival Calender",
                            slug: "festival-calender",
                            icon: "fas fa-calendar-alt",
                            layout: {
                                screen: "content_calender",
                            },
                            app: 4,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 60,
                            status: "published",
                            sort: 12,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T18:54:46",
                            name: "Qureal Trends",
                            slug: "trends",
                            icon: "fas fa-chart-line",
                            layout: {
                                screen: "trends_home",
                            },
                            app: 4,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 52,
                            status: "published",
                            sort: 13,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T18:55:29",
                            name: "Brand Assets",
                            slug: "brand-assets",
                            icon: "fas fa-images",
                            layout: {
                                screen: "brand_assets",
                            },
                            app: 4,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 11,
                            status: "published",
                            sort: 14,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2022-10-14T18:27:56",
                            name: "Trash",
                            slug: "trash",
                            icon: "fas fa-trash-alt",
                            layout: {
                                type: "static",
                            },
                            app: 4,
                            type: "static",
                            components: [27, 28],
                        },
                    ],
                }}
            />
        ),
    },
    settings: {
        slug: "settings",
        name: "Settings",
        icon: "cog-6-tooth",
        component: (props) => (
            <QurealApp
                {...props}
                app={{
                    slug: "settings",
                    name: "Settings",
                    layout: {
                        type: "multiscreen",
                        navigation: {
                            type: "sidebar",
                            theme: "light",
                        },
                    },
                    default_screen_index: 0,
                    screens: [
                        {
                            id: 65,
                            status: "published",
                            sort: 1,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T18:57:03",
                            name: "Account Settings",
                            slug: "account-settings",
                            icon: "fas fa-cog",
                            layout: {
                                screen: "account_settings",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 75,
                            status: "published",
                            sort: 3,
                            user_updated: null,
                            date_updated: null,
                            name: "Social Accounts",
                            slug: "social-accounts",
                            icon: "fas fa-share-alt",
                            layout: {
                                screen: "social_accounts",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 50,
                            status: "published",
                            sort: 2,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2024-12-05T01:32:35",
                            name: "Manage Brands",
                            slug: "brands",
                            icon: "fas fa-layer-group",
                            layout: {
                                screen: "manage_brand",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 51,
                            status: "published",
                            sort: 42,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-01-22T20:24:20",
                            name: "My Collections",
                            slug: "my-collections",
                            icon: "fas fa-box",
                            layout: {
                                screen: "my_collections",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 56,
                            status: "published",
                            sort: 48,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T18:56:46",
                            name: "AI Person Studio",
                            slug: "ai-person-studio",
                            icon: "fas fa-user-tie",
                            layout: {
                                screen: "ai_image_gen",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },

                        {
                            id: 66,
                            status: "published",
                            sort: 53,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T18:57:51",
                            name: "Model Manager",
                            slug: "model-manager",
                            icon: "fas fa-users",
                            layout: {
                                screen: "model_manager",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 68,
                            status: "published",
                            sort: 4,
                            // user_updated:
                            //     "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            // date_updated: "2025-07-30T18:57:51",
                            name: "Billing & Subscription",
                            slug: "billing",
                            icon: "fas fa-credit-card",
                            layout: {
                                screen: "billing_page",
                            },
                            app: 17,
                            type: "qbuilt",
                            components: [],
                        },
                    ],
                }}
            />
        ),
    },
    you: {
        slug: "you",
        name: "You",
        icon: "user-circle",
        component: (props) => <MobileMenuScreen {...props} />,
    },
    design_admin: {
        slug: "design-admin",
        name: "Design Admin",
        icon: "swatch",
        component: (props) => (
            <QurealApp
                {...props}
                app={{
                    slug: "design-admin",
                    name: "Design Admin",
                    layout: {
                        type: "multiscreen",
                        navigation: {
                            type: "sidebar",
                            theme: "light",
                        },
                    },
                    default_screen_index: 0,
                    screens: [
                        {
                            id: 62,
                            status: "published",
                            sort: 42,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T19:02:04",
                            name: "Preset Manager",
                            slug: "preset-manager",
                            icon: "fas fa-folder",
                            layout: {
                                screen: "preset_manager",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 74,
                            status: "published",
                            sort: 43,
                            user_updated: null,
                            date_updated: null,
                            name: "Concept Presets",
                            slug: "concept-preset",
                            icon: "fas fa-palette",
                            layout: {
                                screen: "concept_preset_manager",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 55,
                            status: "published",
                            sort: 44,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T19:02:41",
                            name: "Templates Manager",
                            slug: "templates-manager",
                            icon: "fas fa-copy",
                            layout: {
                                screen: "templates_manager",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 69,
                            status: "published",
                            sort: 45,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-08-08T11:36:21",
                            name: "Graphics Manager",
                            slug: "graphics-manager",
                            icon: "fas fa-splotch",
                            layout: {
                                screen: "graphics_manager",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 58,
                            status: "published",
                            sort: 46,
                            user_updated:
                                "45560a69-46cb-4a3a-93ac-25dd38cdecc2",
                            date_updated: "2025-07-30T19:00:45",
                            name: "Festival Manager",
                            slug: "festival-manager",
                            icon: "fas fa-gift",
                            layout: {
                                screen: "festival_manager",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 70,
                            status: "published",
                            sort: 47,
                            user_updated: null,
                            date_updated: null,
                            name: "File Master",
                            slug: "file-master",
                            icon: "fas fa-folder-open",
                            layout: {
                                screen: "file_master",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 72,
                            status: "published",
                            sort: 55,
                            user_updated: null,
                            date_updated: null,
                            name: "Design Dashboard",
                            slug: "design-dashboard",
                            icon: "fas fa-tachometer-alt",
                            layout: {
                                screen: "dashboard_design",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 73,
                            status: "published",
                            sort: 56,
                            user_updated: null,
                            date_updated: null,
                            name: "Category Map",
                            slug: "category-map",
                            icon: "fas fa-sitemap",
                            layout: {
                                screen: "category_map",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 755,
                            status: "published",
                            sort: 57,
                            user_updated: null,
                            date_updated: null,
                            name: "AI Image Studio",
                            slug: "ai_image_studio",
                            icon: "fas fa-magic",
                            layout: {
                                screen: "ai_image_gen",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        //adding the new schedule post ui here
                        {
                            id: 900,
                            status: "published",
                            sort: 58,
                            user_updated: null,
                            date_updated: null,
                            name: "Scheduled Posts",
                            slug: "schedule-post",
                            icon: "fas fa-clock",
                            layout: {
                                screen: "schedule_post",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 902,
                            status: "published",
                            sort: 59,
                            user_updated: null,
                            date_updated: null,
                            name: "Sandbox",
                            slug: "sandbox_2",
                            icon: "fas fa-clock",
                            layout: {
                                screen: "sandbox_2",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 9023,
                            status: "published",
                            sort: 61,
                            user_updated: null,
                            date_updated: null,
                            name: "Factory",
                            slug: "factory",
                            icon: "fas fa-industry",
                            layout: {
                                screen: "factory",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                        {
                            id: 9023,
                            status: "published",
                            sort: 61,
                            user_updated: null,
                            date_updated: null,
                            name: "Mockup Maker",
                            slug: "mockup-maker",
                            icon: "fas fa-industry",
                            layout: {
                                screen: "mockup_maker",
                            },
                            app: 23,
                            type: "qbuilt",
                            components: [],
                        },
                    ],
                }}
            />
        ),
    },
};

const Home = () => {
    const isMobile = useMedia("(max-width: 700px)");
    const [selectedMenu, setSelectedMenu] = useAtom(selectedMenuAtom);
    const match = useRouteMatch("/:app");
    const { isLoading, isSuccess, data: dataMe, refetch } = useCurrentUser();
    const selectOrgMutation = useSelecteOrgMutation();
    const createOrgMutation = useCreateOrg(() => {
        refetch();
    });
    const { logout } = useLogout();
    const query_params = useQueryParams();

    log.d(dataMe, "dataMe in Home");

    useEffect(() => {
        if (!selectedMenu) {
            setSelectedMenu(match?.params?.app);
        }
    }, [match]);

    useEffect(() => {
        if (isSuccess && dataMe?.organizations?.length > 0) {
            const all_orgs = dataMe?.organizations;
            const selected_org = dataMe?.selected_org;
            log.d(selected_org, "Updating selected org");
            if (!selected_org && selectOrgMutation.isIdle) {
                log.p("Selecting default org now");
                selectOrgMutation.mutate(
                    all_orgs?.[0]?.qdb_organization_id?.id
                );
            }
        } else if (
            isSuccess &&
            !isLoading &&
            dataMe?.organizations?.length === 0
        ) {
            const { from } = history.location.state || {
                from: { pathname: "/new_setup" },
            };
            history.push(from);
        }
    }, [isSuccess, dataMe, selectOrgMutation]);

    useEffect(() => {
        if (isSuccess && !dataMe?.email) {
            logout();
        }
    }, [isSuccess, dataMe]);

    // Prefetch heavy tabs in background after initial render
    useEffect(() => {
        import("../content_calender_new/ContentCalenderNew");
        import("../ai_home/AIHome");
    }, []);

    // if (isSuccess && !dataMe?.mobile_verified) {
    //     const mobile = dataMe?.mobile;
    //     localStorage.setItem("qureal_mobile", mobile);
    //     const { from } = history.location.state || {
    //         from: { pathname: "/verify_otp" },
    //     };
    //     history.push(from);
    // }

    // if (isLoading) {
    //     return <LoadingFull />;
    // }

    const is_celebrate = localStorage.getItem("is_celebrate", false) === "true";

    return (
        <div className={styles.page_wrapper}>
            <PlainLoading visible={!isLoading} />
            {!isMobile && <TopBar me={dataMe} />}
            {isMobile && (
                <div className={styles.topbar}>
                    <QurealSpotlight me={dataMe} />
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Logo />
                    </div>
                    <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <TokenManagerModal
                            selected_org={dataMe?.selected_org}
                            trigger={
                                <TokenCounter
                                    selected_org={dataMe?.selected_org}
                                    isMobile={isMobile}
                                />
                            }
                        />
                    </div>
                </div>
            )}
            {is_celebrate && (
                <Suspense fallback={<></>}>
                    <Celebration />
                </Suspense>
            )}
            <div className={styles.wrapper}>
                {!isMobile && (
                    <DesktopManu
                        selectedMenu={selectedMenu}
                        setSelectedMenu={setSelectedMenu}
                        me={dataMe}
                    />
                )}
                {isMobile && (
                    // <MobileMenu
                    //     selectedMenu={selectedMenu}
                    //     setSelectedMenu={setSelectedMenu}
                    //     me={dataMe}
                    // />
                    <>
                        <div style={{ height: "50px" }}>.</div>
                        <NewMobileNavBar me={dataMe} />
                    </>
                )}

                {/* {!isMobile && <MainBar topbar={false} />} */}

                <div className={styles.app_area}>
                    <Suspense
                        fallback={
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    padding: "60px 0",
                                }}
                            >
                                <Spin size="large" />
                            </div>
                        }
                    >
                        <Switch>
                            <Redirect exact from={`/`} to={`/home`} />

                            {Object.values(APPS).map((item) => {
                                const AppComponent =
                                    item.component || PageNotFound;
                                return (
                                    <Route
                                        key={item.slug}
                                        path={`/${item.slug}`}
                                        component={() => (
                                            <AppComponent me={dataMe} />
                                        )}
                                    />
                                );
                            })}

                            <Route path="*" component={PageNotFound} />
                        </Switch>
                    </Suspense>
                </div>
                {/* {isMobile && <MainBar topbar={true} />} */}
            </div>
            {isMobile && (
                <Suspense fallback={null}>
                    <MobileCreatePanelStandalone
                        open={query_params.get("panel") === "create"}
                        onClose={() =>
                            history.replace(history.location.pathname)
                        }
                        me={dataMe}
                    />
                </Suspense>
            )}
        </div>
    );
};

export default Home;

const MENU_DESKTOP = ["home", "calendar", "creatives", "settings"];
const MENU_MOBILE = ["home", "calendar", "sources", "settings"];

function DesktopManu({ selectedMenu, setSelectedMenu, me }) {
    const final_menus = [
        ...MENU_DESKTOP,
        ...(me?.irole === "reviewer" ? ["design_admin"] : []),
    ];
    return (
        <div className={styles.sidebar_wrapper}>
            <div className={styles.items_wrapper}>
                {final_menus.map((item_key) => {
                    const item = APPS[item_key];
                    return (
                        <Link to={`/${item.slug}`} key={item.slug}>
                            <Popover
                                content={item.name}
                                trigger="hover"
                                placement={"right"}
                            >
                                <div
                                    className={cn({
                                        [styles.item]: true,
                                        [styles.selected]:
                                            selectedMenu === item.slug,
                                    })}
                                    onClick={() => setSelectedMenu(item.slug)}
                                >
                                    {getHeroIcon(item.icon, {
                                        width: "24px",
                                    })}
                                </div>
                            </Popover>
                        </Link>
                    );
                })}
            </div>
            <ThemeSelector>
                <div
                    className={cn({
                        [styles.item]: true,
                        [styles.selected]: false,
                    })}
                >
                    {getHeroIcon("swatch", {
                        width: "24px",
                    })}
                </div>
            </ThemeSelector>
        </div>
    );
}

function MobileMenu({ selectedMenu, setSelectedMenu, me }) {
    return (
        <div className={styles.bottom_bar}>
            {MENU_MOBILE.map((item_key) => {
                const item = APPS[item_key];
                return (
                    <Link to={`/${item.slug}`} key={item.slug}>
                        <Popover
                            content={item.name}
                            trigger="hover"
                            placement={"top"}
                        >
                            <div
                                className={cn({
                                    [styles.item]: true,
                                    [styles.selected]:
                                        selectedMenu === item.slug,
                                })}
                                onClick={() => setSelectedMenu(item.slug)}
                            >
                                {getHeroIcon(item.icon, {
                                    width: "24px",
                                })}
                            </div>
                        </Popover>
                    </Link>
                );
            })}
            <OrgDropdown isMobile={true} selected_org={me?.selected_org} />
        </div>
    );
}
